module.exports = __webpack_public_path__ + "static/media/Mystica.df609800.png";